import { MicrophoneIcon } from './MicrophoneIcon';

/**
 * author: Google
 * id 18C99959-2A0E-4095-BAEA-F5B266377648
 * name microphone
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microphone.svg
 * tags
 * - Music 
 */
export const KeyboardVoiceIcon = MicrophoneIcon;
export default KeyboardVoiceIcon